import { useCallback, useMemo } from "react"
import { log } from "helpers/logger"
import { useGetQuery } from "hooks/queries"
import { useAccountAlias } from "resources/account"
import { useAiTeammateContext } from "./context"

export default function useFetchMessages() {
  const accountAlias = useAccountAlias()

  const { messages, threadId, setMessages, setError } = useAiTeammateContext()

  const hasMessages = useMemo(() => {
    return messages.length > 0
  }, [messages])

  const { isFetching, refetch } = useGetQuery({
    url: `/api/${accountAlias}/ai/chat/threads/${threadId}?limit=100`,
    // Disable to control when the query is run (using refetch)
    enabled: false,
  })

  const fetchMessages = useCallback(async () => {
    setError(null)
    const { isSuccess, data, isError, error } = await refetch()

    if (isSuccess) {
      setMessages(data.messages)
    } else if (isError) {
      setError(error)
      log(error)
    }
  }, [refetch, setMessages, setError])

  return { isFetchingMessages: isFetching, hasMessages, fetchMessages }
}
